// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/js/font'
import './common/style/common.css'
import 'swiper/dist/css/swiper.css';
// import swiper from 'swiper'

Vue.config.productionTip = false
Vue.prototype.$appName = '乡颜';
Vue.prototype.$company = '四川省煊悦网络信息科技有限公司';
Vue.prototype.$companyShort="煊悦网络";
Vue.prototype.$beian = '蜀ICP备2024086314号';
Vue.prototype.$gbeian = '粤公网安备44010602013039号';
Vue.prototype.$email = 'scxy2024@163.com';
Vue.prototype.$siteType = '交友';
Vue.prototype.$apk = '';

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js